import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/torque-calculator',
  component: () => import('../../routes/TorqueCalculator.svelte'),
  card: {
    id: 'torque-calculator',
    title: 'Torque',
    description:
      'Calculate torque using τ = F × r × sin(θ), τ = I × α, or τ = P / ω. Includes N·m ↔ lb·ft conversion, RPM ↔ rad/s, and horsepower output. Complements existing force, power, and momentum calculators.',
    icon: 'autorenew',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/torque-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title:
      'Torque Calculator – Compute τ = F·r·sin(θ), τ = I·α, or P = τ·ω',
    description:
      'Free torque calculator using all three standard formulas: force × lever arm, moment of inertia × angular acceleration, and power ÷ angular velocity. Includes N·m ↔ lb·ft conversion, RPM ↔ rad/s, and horsepower output.',
  },
};

export default meta;